import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function permissionGroupsFetch(requestor) {
  return createReduxPromiseAction(ActionTypes.PERMISSION_GROUPS_FETCH, () =>
    requestor
      .get(`${basePath}/permission_group`, {
        withCredentials: true,
      })
      .then(response => response.data),
  );
}
